import {
  ACTIVITY_DUPLICATION_FIELDS,
  CAR_RENTAL_DUPLICATION_FIELDS,
  FLIGHT_DUPLICATION_FIELDS,
  HOTEL_DUPLICATION_FIELDS,
  VEHICLE_WITH_CHAUFFEUR_DUPLICATION_FIELDS,
} from '@/constants/benefitFields';
import { BenefitType } from '@/types/benefits/benefitTypes';
import { Translator } from '@/types/translator.type';

export const getBenefitDuplicationFields = ({
  type,
  carRental,
  hotel,
  t,
}: {
  type: BenefitType;
  carRental?: {
    carCategories: {
      id: string;
      model: string;
      category: string;
    }[];
  };
  hotel?: {
    HotelRoomCategory: {
      id: string;
      name: string;
    }[];
  };
  t: Translator;
}) => {
  switch (type) {
    case BenefitType.ACTIVITY:
    case BenefitType.MEAL:
    case BenefitType.TRANSFER:
      return ACTIVITY_DUPLICATION_FIELDS(t);
    case BenefitType.VEHICLE_WITH_CHAUFFEUR:
      return VEHICLE_WITH_CHAUFFEUR_DUPLICATION_FIELDS(t);
    case BenefitType.VEHICLE:
      return CAR_RENTAL_DUPLICATION_FIELDS(t).concat(
        carRental
          ? carRental.carCategories.map((category, index) => ({
              label:
                category.category && category.model
                  ? `${category.category}- ${category.model}`
                  : `Véhicule ${index + 1}`,
              value: `carCategories;${category.id}`,
            }))
          : [],
      );
    case BenefitType.VOL:
      return FLIGHT_DUPLICATION_FIELDS(t);
    case BenefitType.HOTEL:
      return HOTEL_DUPLICATION_FIELDS(t).concat(
        hotel
          ? hotel.HotelRoomCategory.map((category, index) => ({
              label: category.name
                ? `${category.name}`
                : `Catégorie ${index + 1}`,
              value: `hotelRoomCategories;${category.id}`,
            }))
          : [],
      );
  }
};
